import React, { FC } from 'react';
import { Col, FormFeedback, Input, Label } from 'reactstrap';
import { restrictSpace } from '../Common/Util';

interface InputComponentProps {
    field: {
        xs?: string;
        sm?: string;
        md?: string;
        lg?: string;
        xl?: string;
        label: string;
        value: string;
        mandatory?: boolean;
        type: string | any;
        disabled?: boolean;
        maxLen?: number;
        rows?: number;
        heading?: string;
        
    };
    labelCss?: string;
    inputCss?: string;
    mode: string;
    inputGroup?: boolean;
    labelBold?:boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    validation: {
        values: { [key: string]: string };
        handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
        handleBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
        touched: { [key: string]: boolean };
        errors: { [key: string]: string };
    };
}

const InputComponent: FC<InputComponentProps> = (props) => {
    return (
        <Col xs={props.field?.xs} sm={props.field?.sm} md={props.field?.md} lg={props.field?.lg} xl={props.field?.xl}>
            <div className={`mt-2 ${props.inputCss} ${props?.inputGroup && 'input-group align-bottom'}`}>
                <div className="mb-2 fw-bold">{props.field?.heading ? props.field?.heading : undefined} </div>
                {props.field?.label && !props?.inputGroup ? (
                    <Label htmlFor={props.field?.value} className={`form-label m-0 mb-1 ${props.labelCss && props.labelCss}`}>
                        {props.field.label}
                        {props.mode !== 'view' && <span className="text-danger ps-1"> {props.field.mandatory ? '*' : ''}</span>}
                        {props.mode === 'view' && <span className="ps-1"> :</span>}
                    </Label>
                ) : (
                    <Label
                        htmlFor={props.field?.value}
                        id="basic-addon1"
                        className={`form-label ${props?.inputGroup && 'input-group-text'} ${props?.labelBold && 'thin-label'} ${props.labelCss && props.labelCss}`}
                    >
                        {props.field.label}
                        {props.mode !== 'view' && <span className="text-danger ps-1"> {props.field.mandatory ? '*' : ''}</span>}
                        {props.mode === 'view' && <span className="ps-1"> :</span>}
                    </Label>
                )}
                {props.mode === 'view' ? (
                    <span className="ps-1"> {props.validation.values[props.field?.value] || ''}</span>
                ) : (
                    <Input
                        className={` ${props?.inputGroup && 'rounded-0'}`}
                        name={props.field?.value}
                        type={props.field?.type}
                        placeholder={`${'Enter'} ${props.field.label}`}
                        disabled={props.field?.disabled}
                        onChange={(e: any) => {
                            props.validation.handleChange(e);
                            if (props?.onChange) {
                                props?.onChange(e);
                            }
                        }}
                        maxLength={props.field?.maxLen}
                        rows={props.field?.rows ? props.field?.rows : 3}
                        onBlur={props.validation?.handleBlur}
                        value={props.validation?.values[props.field?.value] || ''}
                        invalid={
                            props.validation?.touched[props.field?.value] && props.validation.errors[props.field?.value] ? true : false
                        }
                        onKeyDown={(ev) => restrictSpace(ev, props.field, props.validation)}
                        autoComplete="off"
                    />
                )}

                {props.validation?.touched[props.field?.value] && props.validation.errors[props.field?.value] ? (
                    <FormFeedback type="invalid">
                        <div>{props.validation.errors[props.field?.value]}</div>
                    </FormFeedback>
                ) : null}
            </div>
        </Col>
    );
};

export default InputComponent;
